var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContainerHub',{staticClass:"hub-calendar"},[_c('template',{slot:"header"},[_c('HubHeader',{attrs:{"titleTag":'h1',"title":_vm.title,"email":_vm.email,"colorGuid":_vm.colorGuid,"description":_vm.description,"back-btn":_vm.showDetail}}),(!_vm.showDetail)?_c('TheToolsCalendar'):_vm._e()],1),_c('template',{slot:"body"},[_c('router-view')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }